<div class="spinner" [class.hidden]="!isVisible">
    <div class="spinner-circle medium">

    </div>
</div>
